import { type CSSProperties } from 'react'

export type HeaderStyle = 'lightBlue' | 'white' | 'transparent'

export interface HeaderStyleState {
  headerStyleBase: HeaderStyle
  headerStyle: HeaderStyle
  /**
   * The search overlay is open. Carried in the state because it changes the bar's colour *and* how
   * fast it gets there: the overlay mounts and unmounts with no animation, so the bar has to keep up
   * with it rather than cross-fade underneath it.
   */
  isSearchOpen: boolean
}

export type HeaderTextCssVariable = '--header-text-color'
export type HeaderColorCssVariable =
  | '--header-background-color'
  | '--header-border-color'
  | '--header-mobile-open-background-color'
  | '--header-mobile-open-border-color'
export type HeaderSpacingCssVariable = '--header-padding-top'
export type HeaderTransitionCssVariable = '--header-transition-duration'
export type HeaderCssVariable =
  | HeaderTextCssVariable
  | HeaderColorCssVariable
  | HeaderSpacingCssVariable
  | HeaderTransitionCssVariable

export type HeaderSpacingCssValue = NonNullable<Exclude<CSSProperties['paddingTop'], number>>
export type HeaderTransitionCssValue = NonNullable<
  Exclude<CSSProperties['transitionDuration'], number>
>
export type HeaderColorCssValue = (typeof HeaderColorCssValue)[keyof typeof HeaderColorCssValue]
export const HeaderColorCssValue = {
  BRAND_NAVY: '#0B2240',
  BRAND_NAVY_3: '#C4D4DE',
  BRAND_RULE_GREY: '#CFCECE',
  WHITE: '#FFFFFF',
  TRANSPARENT: 'transparent',
} as const
export type HeaderCssValue = HeaderColorCssValue | HeaderSpacingCssValue | HeaderTransitionCssValue
